import StripeErrors from "lib/StripeErrors";

export default class StripeOnceOffFlow {
  constructor(stripeManager) {
    this.stripeManager = stripeManager;
  }

  /**
   * Executes a once-off Stripe payment, submitting the relevant details to the
   * backend using `submitForm()` and then completing payment using
   * `confirmCardPayment()`
   * @return {Promise<unknown>}
   */
  async executePayment() {
    const paymentMethodResponse = await this.stripeManager.createPaymentMethod();
    if (paymentMethodResponse.error) {
      throw StripeErrors(paymentMethodResponse);
    }
    const { id: stripePaymentIntentId, client_secret: clientSecret } = await
      this.stripeManager.savePaymentIntent(paymentMethodResponse.paymentMethod.id);
    await this.stripeManager.submitForm({
      paymentTokens: { paymentData: { stripePaymentIntentId } },
    });
    const cardPaymentResponse = await this.stripeManager.confirmCardPayment({ clientSecret });
    if (cardPaymentResponse.error) {
      throw StripeErrors(cardPaymentResponse);
    }
  }
}
